export default __webpack_public_path__ + "static/media/Q_Quadro.79303687.svg";